// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__FV28D","content":"Layout_content__UOgH6","iframe":"Layout_iframe__7iRX8","iframeOverlay":"Layout_iframeOverlay__QqYSo","floatButton":"Layout_floatButton__vjqPy"};